import { SxProps, Theme } from "@mui/material";
import styled from "styled-components";

import { SVG_BG } from "@ryde/assets";
import { IStyledAttributes } from "@ryde/shared";
import {
  deepPurpleMui,
  greyMui,
  MOBILE_BREAKPOINT,
  redMui,
  rydeColors,
} from "@ryde/theme";

export const buttonResetPasswordSx: SxProps<Theme> = {
  height: "42px",
};

export const MainResetPasswordContainerStyled = styled.div.attrs<IStyledAttributes>(
  {
    "data-e2e": "main-reset-password-container",
  },
)`
  display: grid;
  justify-content: center;
  grid-template-columns: 640px 1fr 362px 1fr;
  grid-template-rows: 1fr 2fr 1fr 96px;
  grid-template-areas:
    "leftimage padgap centertop right"
    "leftimage padgap resetform right"
    "leftimage padgap centerbottom right"
    "leftimage bottombar bottombar bottombar";
  gap: 0 0;
  height: 100vh;
  width: 100vw;
  @media (max-width: ${MOBILE_BREAKPOINT}) {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    box-sizing: border-box;
    position: fixed;
    inset: 0;
    width: 100%;
    max-width: 100%;
    max-height: 100dvh;
    padding-block: max(16px, env(safe-area-inset-top, 0px))
      max(16px, env(safe-area-inset-bottom, 0px));
    padding-inline: max(16px, env(safe-area-inset-left, 0px))
      max(16px, env(safe-area-inset-right, 0px));
    overflow-x: hidden;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
  }
`;

export const LeftImageResetPassword = styled.div<{ $isAdminApp?: boolean }>`
  grid-area: leftimage;
  width: 640px;
  height: 100%;

  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  svg.logo {
    position: absolute;
    margin-top: 62px;
    inset-inline-start: 50px;
    align-self: flex-start;
  }
  background: no-repeat center
    ${({ $isAdminApp }) => {
      if ($isAdminApp) {
        return `url(${SVG_BG.LoginSvgAdminBg}) #2c2c2c`;
      }

      return `url(${SVG_BG.LoginSvgBg}) #140B4E`;
    }};
  background-size: cover;
`;

export const CopyrightLine = styled.div`
  grid-area: bottombar;
  display: flex;
  align-items: stretch;
  justify-content: center;
  color: rgba(0, 0, 0, 30%);
  font-size: 14px;
  div {
    border-top: 1px solid ${rydeColors.grey};
    width: 500px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  @media (max-width: ${MOBILE_BREAKPOINT}) {
    div {
      width: 95%;
    }
  }
`;

export const ResetPasswordFormStyled = styled.div.attrs<IStyledAttributes>({
  "data-e2e": "reset-password-form",
})`
  grid-area: resetform;
  max-width: 347px;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  .MuiFormControl-root {
    width: 100%;
  }
  .singInTitle {
    font: 20px;
    font-weight: 700;
    color: ${greyMui._700};
    height: 30px;
  }

  .authButtons {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    gap: 12px;
    margin-bottom: 8px;
  }

  .authArea {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    gap: 16px;
    margin-top: 8px;
    .labelSignIn {
      line-height: 16px;
      font-size: 12px;
      font-weight: 700;
      color: ${greyMui._700};
    }
    .optionsSignIn {
    }
    .fieldContainer {
    }
    .userNameLabels {
      display: flex;
      align-items: center;
      justify-content: space-between;
      i {
        color: ${redMui._600};
      }
      .forgotPasswordLabel {
        color: ${deepPurpleMui.A400};
      }
    }
    .policyText {
      line-height: 1.6;
      a {
        text-decoration: underline;
        color: ${deepPurpleMui.A400};
        margin-inline-start: 5px;
        margin-inline-end: 5px;
      }
    }
  }

  @media (max-width: ${MOBILE_BREAKPOINT}) {
    width: 100%;
    max-width: 347px;
    flex-shrink: 0;
    padding-inline: 0;
  }
`;
